import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { BaseEntityService } from '@/modules/core/app/services/abstracts/BaseEntityService';
import { CustomHeader } from '@/modules/core/app/constants/api.constants';

export abstract class BaseScopableEntityService<
  T extends BaseEntityModel
> extends BaseEntityService<T> {
  async getEntitiesWithoutUserEstateScope(params: Params = {}): Promise<T[]> {
    params = this.addParams(params ?? {});

    return this.resource.getItems(params, { [CustomHeader.WITHOUT_USER_ESTATE_SCOPE]: true });
  }

  async getEntityWithoutUserEstateScope(id: number | string, params: Params = {}): Promise<T> {
    params = this.addParams(params ?? {});

    return this.resource.getItem(id, params, { [CustomHeader.WITHOUT_USER_ESTATE_SCOPE]: true });
  }
}
